var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "CircleLamp",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-circle-lamp","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <polygon points="156.4,48.8 97,48.8 84.8,95.4 168.7,95.4"/>
  <path d="M133.1 104.4h-12.5c2.7 7.2 5.7 20.5 2.2 38.6-.2 2.1-2.1 16.7-11.4 30.2-.2.3-.6.8-1 1.4-.6.8-1.4 1.8-1.8 2.5-2.8 4.2-6.7 12.6-1.2 21.5l3.4 4.9h33l3.2-5.1c.3-.5 6.2-10.2-3.1-22l-.4-.5c-.9-1.1-2.5-3.1-3.5-4.8-3.5-5.5-9.6-17.9-10.1-30-.1-2.6-1.2-23.3 3.2-36.7z"/>
  <path d="M125.5-1C56-1-.5 55.5-.5 125s56.5 126 126 126 126-56.5 126-126S195-1 125.5-1zm13.4 141.7c.5 10.2 5.9 21.2 8.7 25.6.8 1.2 2.3 3.1 3 4l.4.5c13.3 17.1 3.9 31.8 3.5 32.4l-5.8 9.3H106l-6.2-9.1c-8.5-13.7-1.9-26.5 1.3-31.3.6-.9 1.4-2 2.1-2.9.3-.5.6-.9.8-1.1 8.5-12.3 9.9-26 9.9-26.2l.1-.4c3.9-20-1.1-33-3.1-37.1H73.2l16.9-64.5h73.2l17.1 64.5h-37.6c-4.4 8.9-4.3 28.9-3.9 36.3z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/circle-lamp.svg